// extracted by mini-css-extract-plugin
export var videoInColumn = "style-module--video-in-column--f1e3e";